import Typewriter from "typewriter-effect";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";

function Type() {
  const { lang } = useLang();
  const strings = translations[lang].typeStrings;

  return (
    <Typewriter
      key={lang}
      options={{
        strings,
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
